// Auto-generated Web Components Map

import Web_Roadmap from "./Web_Roadmap.jsx";
import Web_HTTP from "./Web_HTTP.jsx";
import Web_HTML from "./Web_HTML.jsx";
import Web_CSS from "./Web_CSS.jsx";
import Web_Responsive from "./Web_Responsive.jsx";
import Web_JavaScript from "./Web_JavaScript.jsx";
import Web_ES5 from "./Web_ES5.jsx";
import Web_HTML_DOM from "./Web_HTML_DOM.jsx";
import Web_Google_Maps from "./Web_Google_Maps.jsx";
import Web_Google_Fonts from "./Web_Google_Fonts.jsx";
import Web_Google_Charts from "./Web_Google_Charts.jsx";
import Web_XML from "./Web_XML.jsx";
import Web_AJAX from "./Web_AJAX.jsx";
import Web_JSON from "./Web_JSON.jsx";
import Web_CSS_Icons from "./Web_CSS_Icons.jsx";
import Web_Bootstrap from "./Web_Bootstrap.jsx";
import Web_W3CSS from "./Web_W3CSS.jsx";
import Web_CLI from "./Web_CLI.jsx";
import Web_NPM from "./Web_NPM.jsx";
import Web_GitHub from "./Web_GitHub.jsx";
import Web_jQuery from "./Web_jQuery.jsx";
import Web_AngularJS from "./Web_AngularJS.jsx";
import Web_React from "./Web_React.jsx";
import Web_Vue from "./Web_Vue.jsx";
import Web_W3JS from "./Web_W3JS.jsx";
import Web_Frontend from "./Web_Frontend.jsx";
import Web_Fullstack from "./Web_Fullstack.jsx";
import Web_Fullstack_JS from "./Web_Fullstack_JS.jsx";
import Web_SQL from "./Web_SQL.jsx";
import AWS_EC2 from "./AWS_EC2.jsx";
import AWS_RDS from "./AWS_RDS.jsx";
import AWS_Cloudfront from "./AWS_Cloudfront.jsx";
import AWS_SNS from "./AWS_SNS.jsx";
import AWS_Elastic_Beanstalk from "./AWS_Elastic_Beanstalk.jsx";
import AWS_Auto_Scaling from "./AWS_Auto_Scaling.jsx";
import AWS_IAM from "./AWS_IAM.jsx";
import AWS_Aurora from "./AWS_Aurora.jsx";
import AWS_DynamoDB from "./AWS_DynamoDB.jsx";
import AWS_Personalize from "./AWS_Personalize.jsx";
import AWS_Rekognition from "./AWS_Rekognition.jsx";
import AWS_Quicksight from "./AWS_Quicksight.jsx";
import AWS_Polly from "./AWS_Polly.jsx";
import AWS_Pinpoint from "./AWS_Pinpoint.jsx";

const webComponentsMap = {
  "<Web_Roadmap />": Web_Roadmap,
  "<Web_HTTP />": Web_HTTP,
  "<Web_HTML />": Web_HTML,
  "<Web_CSS />": Web_CSS,
  "<Web_Responsive />": Web_Responsive,
  "<Web_JavaScript />": Web_JavaScript,
  "<Web_ES5 />": Web_ES5,
  "<Web_HTML_DOM />": Web_HTML_DOM,
  "<Web_Google_Maps />": Web_Google_Maps,
  "<Web_Google_Fonts />": Web_Google_Fonts,
  "<Web_Google_Charts />": Web_Google_Charts,
  "<Web_XML />": Web_XML,
  "<Web_AJAX />": Web_AJAX,
  "<Web_JSON />": Web_JSON,
  "<Web_CSS_Icons />": Web_CSS_Icons,
  "<Web_Bootstrap />": Web_Bootstrap,
  "<Web_W3CSS />": Web_W3CSS,
  "<Web_CLI />": Web_CLI,
  "<Web_NPM />": Web_NPM,
  "<Web_GitHub />": Web_GitHub,
  "<Web_jQuery />": Web_jQuery,
  "<Web_AngularJS />": Web_AngularJS,
  "<Web_React />": Web_React,
  "<Web_Vue />": Web_Vue,
  "<Web_W3JS />": Web_W3JS,
  "<Web_Frontend />": Web_Frontend,
  "<Web_Fullstack />": Web_Fullstack,
  "<Web_Fullstack_JS />": Web_Fullstack_JS,
  "<Web_SQL />": Web_SQL,
  "<AWS_EC2 />": AWS_EC2,
  "<AWS_RDS />": AWS_RDS,
  "<AWS_Cloudfront />": AWS_Cloudfront,
  "<AWS_SNS />": AWS_SNS,
  "<AWS_Elastic_Beanstalk />": AWS_Elastic_Beanstalk,
  "<AWS_Auto_Scaling />": AWS_Auto_Scaling,
  "<AWS_IAM />": AWS_IAM,
  "<AWS_Aurora />": AWS_Aurora,
  "<AWS_DynamoDB />": AWS_DynamoDB,
  "<AWS_Personalize />": AWS_Personalize,
  "<AWS_Rekognition />": AWS_Rekognition,
  "<AWS_Quicksight />": AWS_Quicksight,
  "<AWS_Polly />": AWS_Polly,
  "<AWS_Pinpoint />": AWS_Pinpoint,
};

export default webComponentsMap;
